import classNames from 'classnames';

import style from './TabsContainer.module.css';

interface Props {
  tabs: string[];
  selectedTab: string;
  onChangeSelectedTab: (newTab: string) => void;
  children: React.ReactElement;
  additionnalContainerClassNames?: string;
  additionnalChildrenClassNames?: string;
  responsive?: boolean;
}

export default function CustomTabs({
  children,
  tabs,
  selectedTab,
  onChangeSelectedTab,
  additionnalContainerClassNames,
  additionnalChildrenClassNames,
}: Props) {
  return (
    <div className={classNames(style.tabContainer, additionnalContainerClassNames)}>
      <div className={style.top}>
        {tabs.map((tab) => (
          <div
            className={classNames(style.tab, {
              [style.selectedTab]: selectedTab === tab,
            })}
            onClick={() => onChangeSelectedTab(tab)}
          >
            <p>{tab}</p>
          </div>
        ))}
      </div>

      <div className={classNames(style.childrenContainer, additionnalChildrenClassNames)}>{children}</div>
    </div>
  );
}
